/**
 * Page numbers to render in a pager, with `null` marking an ellipsis. Always includes the first and
 * last page so both ends stay one click away, plus a `span`-wide window around the current page.
 */
export function pageWindow(page: number, totalPage: number, span = 1): (number | null)[] {
  if (totalPage <= 1) return [1];
  // A page outside the range still has to render a sane strip (e.g. a hand-edited ?p= in the URL).
  const current = Math.min(Math.max(page, 1), totalPage);
  const wanted = new Set<number>([1, totalPage]);
  for (let p = current - span; p <= current + span; p++) {
    if (p >= 1 && p <= totalPage) wanted.add(p);
  }
  const sorted = [...wanted].sort((a, b) => a - b);
  const out: (number | null)[] = [];
  let prev = 0;
  for (const p of sorted) {
    // An ellipsis hiding a single page costs the same width as the page itself — show the page.
    if (prev && p - prev === 2) out.push(p - 1);
    else if (prev && p - prev > 2) out.push(null);
    out.push(p);
    prev = p;
  }
  return out;
}
